var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 11.75C15.6709 11.75 14.9993 12.4216 14.9993 13.25C14.9993 14.0784 15.6709 14.75 16.4993 14.75C17.3277 14.75 17.9993 14.0784 17.9993 13.25C17.9993 12.4216 17.3277 11.75 16.4993 11.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94922 4C2.84465 4 1.94922 4.89543 1.94922 6V17.25C1.94922 18.7688 3.18044 20 4.69922 20H18.1992C20.2703 20 21.9492 18.3211 21.9492 16.25V10.25C21.9492 8.8258 21.1553 7.58702 19.9858 6.95214C19.8354 5.29682 18.4438 4 16.7493 4H3.94922ZM4.69922 18.5C4.00886 18.5 3.44922 17.9404 3.44922 17.25V7.93699C3.60903 7.97812 3.77657 8 3.94922 8H18.1992C19.4419 8 20.4492 9.00736 20.4492 10.25V16.25C20.4492 17.4927 19.4419 18.5 18.1992 18.5H4.69922ZM3.94922 6.5C3.67307 6.5 3.44922 6.27615 3.44922 6C3.44922 5.72385 3.67307 5.5 3.94922 5.5H16.7493C17.4483 5.5 18.0516 5.90983 18.332 6.50231C18.2879 6.50077 18.2436 6.5 18.1992 6.5H3.94922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet4);
export default __webpack_public_path__ + "static/media/wallet-4.5cdbd0cc80be09ae4425ab76c8d302d0.svg";
export { ForwardRef as ReactComponent };